<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('user.myInvestment') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/moneybag')"
      >
        <van-icon
          name="bars"
          size="25"
        />
      </div>
    </div>
    <div class="head-tabs">
      <a
        href="#/vip"
        class="tab-item "
      >{{ $t('income.title2') }}</a>
      <a
        href="#/item"
        class="tab-item "
      >{{ $t('income.title3') }}</a>
      <a
        href="#/order"
        class="tab-item active"
      >{{ $t('income.investr') }}</a>
    </div>
		
    <div class="money_box">
      <div class="item">
        <p
          class="money_num"
          v-html="'<span>'+utils_moneyMark()+'</span> '+ data.on_money?data.on_money:0"
        />
        <p class="info">
          {{ $t('user.uncollectedPrincipal') }}
        </p>
      </div>
      <div class="item">
        <p
          class="money_num"
          v-html="'<span>'+utils_moneyMark()+'</span> '+data.on_apr_money?data.on_apr_money:0"
        />
        <p class="info">
          {{ $t('user.uncollectedInterest') }}
        </p>
      </div>
      <div class="item">
        <p
          class="money_num"
          v-html="'<span>'+utils_moneyMark()+'</span> '+data.ok_apr_money?data.ok_apr_money:0"
        />
        <p class="info">
          {{ $t('user.cumulativeIncome') }}
        </p>
      </div>
    </div>
    <h3 class="notes_tit">
      {{ $t('orders.record') }}
    </h3>
    <van-empty
      v-if="empty"
      :description="$t('orders.noOrders')"
    />
    <div class="scrollBox">
      <div
        v-for="i in data.list"
        v-if="!empty"
        class="notes_box invest"
      >
        <p class="timer">
          <span style="font-size: 16px;color: #333333;font-weight: bold;">
            {{ i.id }}
          </span>
          <!-- {{ i.time }} -->
          <!-- {{$t('utils.count_down')}} {{i.showTime}} -->
          <span
            v-if="i.isling==1"
            class="item_btn"
            style="height: 30px;text-align: center;varticle-align:middle;border-radius: 5px;background-color:green; "
          >
            <button
              type="button"
              style="line-height: 20px;padding: 0px 10px;color: #FFFFFF;"
              @click="receiveRewards(i)"
            >{{ $t('utils.receiveRewards') }}</button>
          </span>
          <span
            v-if="i.isling==0"
            class="item_btn"
            style="height: 30px;text-align: center;varticle-align:middle;border-radius: 5px;background-color: #a8aebb; "
          >
            <button
              type="button"
              style="line-height: 20px;padding: 0px 10px;color: #FFFFFF;"
            >{{ $t('utils.receiveRewards') }}</button>
          </span>
          <!-- <span class="ing" v-if="i.status==0">{{$t('orders.unfinish')}}</span>
					<span class="finish" v-if="i.status==1">{{$t('orders.finish')}}</span> -->
        </p>
        <div class="intsbox">
          <div
            class="itembox"
            @click="$router.push('/item/'+i.pid)"
          >
            <div class="thumb">
              <img
                v-if="i.img && i.img.length>10"
                :src="i.img"
                @click="$router.push('/item/'+i.pid)"
              >
              <img
                v-else
                src="../images/shop2/pro.png"
                @click="$router.push('/item/'+i.pid)"
              >
            </div>
            <div class="intro">
              <p>Days:<span>{{ i.dayindex }}/{{ i.day }}</span></p>
              <p>Daily rate:<span>{{ i.rate }}</span>%</p>
              <p>Invest:<span>{{ i.money }}</span> USDT</p>
            </div>
            <div
              v-if="1*i.total < 1*i.min"
              class="sicon"
            >
              <img
                src="../images/shop2/saleout.png"
                draggable="false"
              >
            </div>
          </div>	
        </div>
        <!-- <div class="item_div1 download">
					<div style="line-height: 30px;font-size: 16px;padding-left: 10px;">
						{{$t('utils.count_down')}} {{i.showTime}}
					</div> 
					<div class="item_btn" v-if="i.isling==1" style="height: 30px;text-align: center;varticle-align:middle;border-radius: 5px;background-color: #3775f4; ">
						<button type="button" style="line-height: 30px;padding: 0px 10px;color: #FFFFFF;" @click="receiveRewards(i)">{{$t('utils.receiveRewards')}}</button>
					</div>
					<div class="item_btn" v-if="i.isling==0" style="height: 30px;text-align: center;varticle-align:middle;border-radius: 5px;background-color: #a8aebb; ">
						<button type="button" style="line-height: 30px;padding: 0px 10px;color: #FFFFFF;">{{$t('utils.receiveRewards')}}</button>
					</div>
				</div> -->
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
    var _that;
	import {
		Dialog
	} from 'vant';
	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	export default {
		name: "Order",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: {},
				doing:0,
				empty: false,
			};
		},
		created() {
			this.$parent.footer("order");
		},
		mounted() {
			this.start();
			_that = this;
		},
		beforeDestroy() {
		    _that.doing = 0;
		},
		methods: {
			start() {
				Fetch("/user/order").then((r) => {
					this.data = r.data;
					r.data.list.length == 0 ?
						(this.empty = true) :
						(this.empty = false);
						if(r.data.list.length>0){
							for(var i=0;i<r.data.list.length;i++){
								if(r.data.list[i].daojishi =='0'){
									r.data.list[i].showTime = '00:00:00';
									continue;
								}
								if(r.data.list[i].day <= r.data.list[i].day_index){
									r.data.list[i].showTime = '00:00:00';
									continue;
								}
								if(r.data.list[i].count_time != ''){
									// _that.countTime(i,true)
									r.data.list[i].leftTime= _that.countTime(i);
								}
							}
							if(_that.doing ==0){
								_that.doing = 1;
								_that.showtimestr();
							}
					}
				});
			},
			wan(str) {
				var num = parseFloat(str);
				if (num > 99999) {
					return `${(num / 10000).toFixed(2)}万`;
				} else {
					return str || 0;
				}
			},
			lookHT(id) {
				this.$router.push("/contract/" + id);
			},
			showtimestr(){
				if(_that.doing == 0){
					return;
				}
				var list = _that.data.list;
				if(list && list.length>0){
					for(var i=0;i<list.length;i++){
						var index = i;
						var leftTime = list[i].leftTime;
						var isling =  list[index].isling
						//定义变量 d,h,m,s保存倒计时的时间
						if (leftTime > 0 && isling == 0) {
							var hh = Math.floor((leftTime / 1000 / 60 / 60) % 24);
							var mm = Math.floor((leftTime / 1000 / 60) % 60);
							var ss = Math.floor((leftTime / 1000) % 60);
							hh = hh>=10?hh:"0"+hh;
							mm = mm>=10?mm:"0"+mm;
							ss = ss>=10?ss:"0"+ss;
							var showTime = hh + ":" + mm + ":" + ss ;
							
							_that.data.list[index].showTime = showTime;
							if(leftTime<1){
								_that.data.list[index].isling = '1';
							}
							_that.data.list[index].leftTime = leftTime-1000;
							
						}else{
							_that.data.list[index].showTime = '00:00:00';
						}
					}
					setTimeout(() => {
						 _that.showtimestr();
					}, 1000);
				}	
			},
			countTime(index) {
				// console.log(this.data.list[index].sys_time );
				var sysTime = this.data.list[index].sys_time;
				var endTime = this.data.list[index].count_time;
				//获取当前时间
				sysTime = sysTime.replace(/-/g,"/");
				endTime = endTime.replace(/-/g,"/");
				var nowdate = new Date(sysTime);
				var now =  nowdate.getTime();
				//设置截止时间
				var endDate = new Date(endTime);
				var end = endDate.getTime();
				//时间差
				var leftTime = parseInt(end - now);
				return leftTime;
			},
			receiveRewards(item){
				var index = -1;
				 for(var i=0;i<this.data.list.length;i++){
					if(this.data.list[i].id==item.id){
							index =i;
						}
				}
				// if(this.data.list[index].isdisabled == true){
				// 	if(this.data.list[index].day <= this.data.list[index].day_index){
				// 		alert('Cannot be claimed repeatedly');			 
				// 	}					
				// 	return;
				// }
				Fetch("/index/receiveRewards", {
				  id: item.id
				}).then(r => {
				   console.log(r );
					Dialog.alert({
						message: window.vm.$i18n.t('item.getincome')+ r.data.price,
						confirmButtonText: window.vm.$i18n.t('utils.confirm')
					});
					
					this.data.list[index].isling = '0'
					var sysdate = new Date(r.data.sys_date);
					var millSeconds = Math.abs(sysdate) + (1000*60*60*24-1);
					var date1 = new Date(millSeconds);
					var M = (date1.getMonth()+1 < 10 ? '0'+(date1.getMonth()+1) : date1.getMonth()+1) + '-';		
					var sysTime = sysdate.getFullYear() + '-' + M + sysdate.getDate() + ' '+ sysdate.getHours() + ':' + sysdate.getMinutes() + ':' + sysdate.getSeconds();			 
					var countTime = date1.getFullYear() + '-' + M + date1.getDate() + ' '+ date1.getHours() + ':' + date1.getMinutes() + ':' + date1.getSeconds();
					this.data.list[index].sys_time = sysTime;
					this.data.list[index].count_time = countTime;
				}).catch(err=>{
					Dialog.alert({
						message: window.vm.$i18n.t('item.getincomefail'),
						confirmButtonText: window.vm.$i18n.t('utils.confirm')
					});
				})
			}
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		
	}

	.money_box {
		display: flex;
		justify-content: space-around;
		border-radius: 10px;
		padding: 10px;
		margin: 10px;
		color:#36333d;
		background: #FFF;

		.item {
			width: 33.33%;
			text-align: center;
			font-weight: bold;

			.money_num {
				font-size: 18px;
				line-height: 25px;
				white-space: normal;
				word-break: normal;
				text-align: center;
			}

			.info {
				font-size: 12px;
				line-height: 20px;
				font-weight: normal;
				margin-top: 5px;
			}
		}
	}

	.notes_tit {
		line-height: 44px;
		height: 44px;
		font-size: 14px;
		color: #000000;
		padding: 0 14px;
		background: #FAFAFA;
		z-index: 2;
		margin: 10px;
		border-radius: 5px;
	}

	.notes_box {
		width: 100%;
		padding-bottom: 2px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-bottom: 10px;

		.timer {
			padding: 3px 3px;
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			border-bottom: 1px solid #ececec;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-style: normal;
				padding: 5px;
				border-radius: 5px;
				color: #FFFFFF;
			}

			.ing {
				background: #3775f4;
			}

			.finish {
				font-style: normal;
				background: #07c160;
			}
		}

		.item_div1 {
			display: flex;
			justify-content: space-between;
			padding: 15px 10px;

			p:nth-child(1) {
				width: 100%;
				font-weight: bold;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

			}
		}

		.item_div2 {
			display: flex;
			justify-content: space-between;
			text-align: center;
			margin-bottom: 5px;
			margin-top: 5px;
			div {
				width: 33.33%;

				p {
					padding: 5px 0;
				}
			}

			.item_rate {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;
					color: #FF0000;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_day {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_min {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}
		}
	}

	.scrollBox {
		width: 96%;
		margin-left: 2%;
	}
	.invest {
	    display: block;
	    padding: 8px;
		.intsbox {
		    display: block;
		    padding-top: 16px;
		}
		.itembox {
		    height: 114px;
		    cursor: pointer;
			background: linear-gradient(270deg, #ee264d,#746b0a);
		    border-radius: 8px;
		    padding: 8px;
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    position: relative;
			.thumb {
			    width: 55%;
				img{
					width: 100%;
					height: 97px;
					display: block;
					border-radius: 8px;
				}
			}
			.intro {
			    width: 42%;
			    color: #eee;
				>p {
				    height: 30px;
				    line-height: 30px;
				    font-weight: 500;
				    font-size: 13px;
					>span {
					    margin: 0 2px 0 5px;
					    zoom: 1.1;
					    color: #fff;
					}
				}
			}
			.sicon {
			    position: absolute;
			    right: 0;
			    bottom: 0;
			    z-index: 8;
				img{
					width: 78px;
					height: 60px;
				}
			}
		}
	}
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #ee264d;;
	    white-space: nowrap;
		border-radius: 10px;
		margin: 10px;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #ababab;
		    transition: all .3s ease;
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;
			
		}
		.active {
		    font-size: 1.5em;
		    color: #282828;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}
</style>
